var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPawnIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4609 14.0266C25.4609 15.7382 24.7323 17.2797 23.5682 18.3576L26.5675 20.4748V24.3544H23.6313C23.7729 26.1527 24.9267 27.9524 26.4198 29.5223C28.0043 31.1882 29.9106 32.5319 31.1767 33.2553L31.3625 33.3615V39.1083H8.125V33.3615L8.31085 33.2553C9.57687 32.5319 11.4832 31.1882 13.0677 29.5223C14.5608 27.9524 15.7146 26.1527 15.8562 24.3544H12.92V20.4748L15.7133 18.503C14.4548 17.4207 13.6577 15.8167 13.6577 14.0266C13.6577 10.7672 16.3 8.125 19.5593 8.125C22.8187 8.125 25.4609 10.7672 25.4609 14.0266Z",
    fill: "#4F4F4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPawnIcon);
export default __webpack_public_path__ + "static/media/PawnIcon.2d6193177125a9cdde8240d61e84d770.svg";
export { ForwardRef as ReactComponent };